module.exports = __webpack_public_path__ + "static/media/logo-whatsapp.9bb37426.svg";